import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  constructor() {

  }

  isFeatureEnabled(feature: string) {
    if (!feature || feature === '' || environment.featureFlags[feature]) {
      return true;
    }
    return false;
  }


}
